import { Tree } from '@geist-ui/core'


export const RenderFolderTree = ({  data }) => {
    
    const defaultNodes = [
        {
            "Path": '/dev',
        }
    ];

    function buildTree(data) {
        const tree = {};
            data.forEach((node) => {
                const pathParts = node.Path.split('/').filter((part) => part !== '');
                let currentLevel = tree;
        
                pathParts.forEach((part, index) => {
                    if (!currentLevel[part]) {
                        if (index === pathParts.length - 1 || node.Path.indexOf('.') === -1) {
                            currentLevel[part] = { isFile: node.Path.indexOf('.') !== -1, children: {} };
                        } else {
                            currentLevel[part] = { isFile: false, children: {} };
                        }
                    }
                    currentLevel = currentLevel[part].children;
                });
            });
      
    
        return tree;
    }
    
    function renderTree(tree) {
        const renderNode = (node, name) => {
            const hasChildren = Object.keys(node.children).length > 0;
            if (hasChildren || !node.isFile) {
                return (
                    <Tree.Folder name={name} key={name}>
                        {Object.entries(node.children).map(([subName, subNode]) =>
                            renderNode(subNode, subName)
                        )}
                    </Tree.Folder>
                );
            } else {
                return <Tree.File name={name} key={name} />;
            }
        };
    
        return Object.entries(tree).map(([name, node]) => renderNode(node, name));
    }
    

    const tree = data ? data.length ? buildTree(data) : buildTree(defaultNodes) : buildTree(defaultNodes);
    
    return <Tree initialExpand='true' >{renderTree(tree)}</Tree>;
}

